import {RequestBase} from "@simplyhealth/iam_client_lib/lib/shared/models";
import {createCognitoConfigSettings} from "./cognito-settings";

export function createGetCurrentLoginRequest(): RequestBase {
    return {
        config: createCognitoConfigSettings()
    };
}
